<div class="snackbar" [ngClass]="{'error': status === 'error', 'success': status === 'success'}">
  <mat-icon *ngIf="showIcon">{{status === 'success' ? 'check_circle' : 'info'}}</mat-icon>
  <p>{{message}}</p>
</div>
